var _path;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgImportant = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M131.014,355.825A1,1,0,0,0,132,357a.867.867,0,0,0,.893-.535,1,1,0,0,1,1.9.627A2.813,2.813,0,0,1,132,359a3,3,0,0,1-2.959-3.5,3.082,3.082,0,0,1,3.066-2.5,1.021,1.021,0,0,0,1.078-.9l.522-5.22a1.685,1.685,0,0,0-.434-1.317,1.759,1.759,0,0,0-2.546,0,1.685,1.685,0,0,0-.434,1.317l.423,4.232a1,1,0,1,1-1.99.2l-.423-4.232a3.715,3.715,0,1,1,7.394,0l-.522,5.22a2.991,2.991,0,0,1-2.985,2.7A1.118,1.118,0,0,0,131.014,355.825Z",
    transform: "translate(-120 -339)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImportant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/important.093b33c7.svg";
export { ForwardRef as ReactComponent };